import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { handleSnackBar } from "./global";
import MESSAGES from "../constants/messages";
// import { postAPICall } from '../utils/axios.util'
// import { nextAPIRoutes } from '../constants/apiRoutes'
import userService from "../services/user.service";

export const saveUserConfig = createAsyncThunk(
  "user/set",
  async ({ data, onSuccess }: any, { dispatch }) => {
    try {
      dispatch(savingUserConfig(true));

      const resp: any = await userService.save({ body: data }); //postAPICall(nextAPIRoutes.USER_CONFIG_SAVE, data)
      dispatch(
        handleSnackBar({
          open: true,
          severity: "success",
          message: "Configurations saved.",
        })
      );
      onSuccess();
      dispatch(getUserConfig());
      dispatch(savingUserConfig(false));
      return resp?.data?.data ?? null;
    } catch (e: any) {
      dispatch(savingUserConfig(false));
      dispatch(
        handleSnackBar({
          open: true,
          severity: "error",
          message: e?.response?.data?.message ?? MESSAGES.ERROR,
        })
      );
      return { items: [] };
    }
  }
);

export const getUserConfig = createAsyncThunk(
  "user/get",
  async (_, { dispatch }) => {
    try {
      const resp: any = await userService.fetch({}); //postAPICall(nextAPIRoutes.USER_CONFIG_FETCH, {})

      return resp?.data?.data ?? null;
    } catch (e: any) {
      dispatch(
        handleSnackBar({
          open: true,
          severity: "error",
          message: e?.response?.data?.message ?? MESSAGES.ERROR,
        })
      );
      return null;
    }
  }
);

export const getUserProfile = createAsyncThunk(
  "user/getUserProfile",
  async (_, { dispatch }) => {
    try {
      dispatch(setLoadingProfile(true));
      const resp: any = await userService.getProfile({ body: {} }); //postAPICall(nextAPIRoutes.GET_PROFILE, {})

      dispatch(setLoadingProfile(false));
      return resp?.data?.data ?? null;
    } catch (e: any) {
      dispatch(
        handleSnackBar({
          open: true,
          severity: "error",
          message: e?.response?.data?.message ?? MESSAGES.ERROR,
        })
      );
      return null;
    }
  }
);

export const updateUserProfile = createAsyncThunk(
  "user/updateUserProfile",
  async ({ data, onSuccess }: { onSuccess?: any; data: any }, { dispatch }) => {
    try {
      dispatch(setSubmittingProfile(true));

      const resp: any = await userService.updateProfile({ body: data }); //postAPICall(nextAPIRoutes.UPDATE_PROFILE, data)

      dispatch(
        handleSnackBar({
          open: true,
          severity: "success",
          message: "Profile saved successfully.",
        })
      );
      dispatch(getUserConfig());
      dispatch(setSubmittingProfile(false));
      if (onSuccess) onSuccess();
      return resp?.data?.data ?? null;
    } catch (e: any) {
      dispatch(setSubmittingProfile(false));
      dispatch(
        handleSnackBar({
          open: true,
          severity: "error",
          message: e?.response?.data?.message ?? MESSAGES.ERROR,
        })
      );
      return { items: [] };
    }
  }
);

const userReducer = createSlice({
  name: "user",
  initialState: {
    userConfig: null,
    savingUserConfig: false,
    userProfile: null as any,
    submittingProfile: false,

    loadingProfile: true,
    userConfigLoading: false,
  },
  reducers: {
    savingUserConfig: (state, { payload }) => {
      state.savingUserConfig = payload;
    },
    setSubmittingProfile: (state, { payload }) => {
      state.submittingProfile = payload;
    },
    updateLocalProfile: (state, { payload }: { payload: object }) => {
      state.userProfile = { ...state.userProfile, ...payload };
    },
    clearLocalUserProfile: (state) => {
      state.userProfile = null;
      state.userConfig = null;
    },
    setLoadingProfile: (state, { payload }) => {
      state.loadingProfile = payload;
    },
  },
  extraReducers: (builder) =>
    builder
      .addCase(getUserConfig.pending, (state) => {
        state.userConfigLoading = true;
      })
      .addCase(getUserConfig.fulfilled, (state, { payload }) => {
        state.userConfig = payload;
        state.userConfigLoading = false;
      })
      .addCase(getUserProfile.fulfilled, (state, { payload }) => {
        state.userProfile = payload;
      }),
});

export default userReducer.reducer;
export const {
  savingUserConfig,
  setSubmittingProfile,
  updateLocalProfile,
  setLoadingProfile,
  clearLocalUserProfile,
} = userReducer.actions;
